import html2canvas from "html2canvas-pro";
import jsPDF from "jspdf";

export const captureElement = async (element) =>
  html2canvas(element, {
    scale: 2,
    useCORS: true,
    logging: false,
    backgroundColor: "#ffffff",
    allowTaint: true,
    scrollY: -window.scrollY,
  });

const addCanvasSliceToPdf = (
  pdf,
  sourceCanvas,
  sourceY,
  pageSourceHeight,
  pageWidth,
  pageHeight,
  padding
) => {
  const contentWidth = pageWidth - padding * 2;
  const scale = contentWidth / sourceCanvas.width;
  const sliceHeight = Math.min(pageSourceHeight, sourceCanvas.height - sourceY);

  const pageCanvas = document.createElement("canvas");
  pageCanvas.width = sourceCanvas.width;
  pageCanvas.height = sliceHeight;

  const context = pageCanvas.getContext("2d");
  context.fillStyle = "#ffffff";
  context.fillRect(0, 0, pageCanvas.width, pageCanvas.height);
  context.drawImage(
    sourceCanvas,
    0,
    sourceY,
    sourceCanvas.width,
    sliceHeight,
    0,
    0,
    sourceCanvas.width,
    sliceHeight
  );

  const imageHeight = sliceHeight * scale;
  pdf.addImage(
    pageCanvas.toDataURL("image/png"),
    "PNG",
    padding,
    padding,
    contentWidth,
    imageHeight
  );
};

const prepareWideTableCapture = (element) => {
  const table = element?.querySelector("table");
  if (!table) return () => {};

  const previous = {
    overflow: element.style.overflow,
    width: element.style.width,
    maxWidth: element.style.maxWidth,
  };

  element.style.overflow = "visible";
  element.style.width = `${table.scrollWidth}px`;
  element.style.maxWidth = `${table.scrollWidth}px`;

  return () => {
    element.style.overflow = previous.overflow;
    element.style.width = previous.width;
    element.style.maxWidth = previous.maxWidth;
  };
};

const hideExportOnlyElements = (element) => {
  const hiddenElements = element.querySelectorAll(".export-hide");
  hiddenElements.forEach((el) => {
    el.dataset.prevDisplay = el.style.display;
    el.style.display = "none";
  });

  return () => {
    hiddenElements.forEach((el) => {
      el.style.display = el.dataset.prevDisplay || "";
      delete el.dataset.prevDisplay;
    });
  };
};

export const exportElementToPdf = async (element, filename) => {
  const restoreHidden = hideExportOnlyElements(element);
  const restoreLayout = prepareWideTableCapture(element);

  try {
    const pdf = new jsPDF("l", "mm", "a4");
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const padding = 10;

    const canvas = await captureElement(element);
    const contentHeight = pageHeight - padding * 2;
    const scale = (pageWidth - padding * 2) / canvas.width;
    const pageSourceHeight = Math.floor(contentHeight / scale);

    let sourceY = 0;
    let pageIndex = 0;

    while (sourceY < canvas.height) {
      if (pageIndex > 0) pdf.addPage();
      addCanvasSliceToPdf(
        pdf,
        canvas,
        sourceY,
        pageSourceHeight,
        pageWidth,
        pageHeight,
        padding
      );
      sourceY += pageSourceHeight;
      pageIndex += 1;
    }

    pdf.save(`${filename}.pdf`);
  } finally {
    restoreLayout();
    restoreHidden();
  }
};
